import React from "react";
import PropTypes from "prop-types";
import Form from "../../common/Form";
import Section from "../../common/Section";
import Table from "../../common/Table";
import CheckBoxWithChild from "../../common/CheckBoxWithChild";
import { RelatieTypes, UserTypes, RelatieTypesEnum } from "../../../constants/DomainConstants";
import { Popup } from "semantic-ui-react";

const LinkOverzichtForm = (props) => {
    const {
        models,
        isNew,
        federatieNaam,
        federatieId,
        sportVlaanderenRoot,
        onChange,
        onChangeLinksCheck,
        onUndo,
        onAdd,
        onSave,
        undoButtonDisabled,
        userType,
        checkboxStatussen,
        showLinkChecks,
        onEditIdentificatieCode,
        identificatieCodeChanged
    } = props;


    
    function mapOnEditIdentificatieCode(organisatieId) {
        return function () {
            onEditIdentificatieCode(organisatieId);
        };
    }
    const tdStyle = { padding: "5px" };

    const linkClass = { "color": "#39b4e8", "font-weight": "bold" };

    const linkRows = models && models.length ? models.map((link, i) => {
        const relatieType = RelatieTypes.find(x => x.value.toString() === link.relatieType.toString());
        if(userType === UserTypes.WEBSITEBEZOEKER && relatieType.value == RelatieTypesEnum.GESUBSIDIEERD_DOOR.toString())
            return null;
        return (<tr style={{ borderStyle: 'solid', borderWidth: "1px", borderColor: '#eeefef', height: '80' }} key={i}>
            {userType === UserTypes.WEBSITEBEZOEKER ?
                <td style={tdStyle}>
                    <CheckBoxWithChild key={i} name={"checked_" + link.id + "_"+ link.relatieType} value={link.checked} label="" onChange={onChange} size={6} />
                </td>
                : null}
            <td style={tdStyle}><a style={linkClass} href={sportVlaanderenRoot + "/sportorganisatie?OrgId=" + link.id} target={"_blank"}>{link.naam} {link.afkorting ? "(" + link.afkorting + ")" : ""}</a></td>
            <td style={tdStyle}>{link.type}</td>
            <td style={tdStyle}>{relatieType ? relatieType.label : ""}</td>
            <td style={tdStyle}>{link.sporttakken && link.sporttakken.split(',').length > 1 ? "Multisport" : link.sporttakken}</td>
            <td style={tdStyle}>
                {link.identificatieCode}
                {
                    userType === UserTypes.FEDERATIEMEDEWERKER && link.id == federatieId &&
                    <Popup trigger={<span onClick={mapOnEditIdentificatieCode(link.id)} style={{ color: '#777', fontSize: '1rem', cursor: 'pointer' }}><i className="fa fa-pencil fa-fw pull-right"></i></span>} content={"Identificatiecode wijzigen"} />
                }
            </td>
        </tr>);
    }) : null;

    const tableHeaders = userType === UserTypes.WEBSITEBEZOEKER ?
        ["", "Naam (afkorting)", "Type", "Soort relatie", "Sporttak","Identificatiecode"] :
        ["Naam (afkorting)", "Type", "Soort relatie", "Sporttak", "Identificatiecode"];

    const tableHeaderSizes = userType === UserTypes.WEBSITEBEZOEKER ?
        [5, 40, 10, 10, 10,10] :
        [40, 10, 10, 10,10];

    const lidVanSportraadCheckbox = <CheckBoxWithChild name="lidVanSportraad" value={checkboxStatussen.lidVanSportraad} label="Is lid van sportraad." onChange={onChangeLinksCheck} size={12} />;
    const erkendDoorCheckbox = <CheckBoxWithChild name="erkendDoorSportdienst" value={checkboxStatussen.erkendDoorSportdienst} label="Is erkend door gemeente." onChange={onChangeLinksCheck} size={12} disabled={checkboxStatussen.gesubsidieerdDoorOverheidsinst} />;
    const gesubsidieerdDoorCheckbox = <CheckBoxWithChild name="gesubsidieerdDoorOverheidsinst" value={checkboxStatussen.gesubsidieerdDoorOverheidsinst} label="Wordt gesubsidieerd door gemeente." onChange={onChangeLinksCheck} size={12} disabled={!checkboxStatussen.erkendDoorSportdienst} />;

    const showCheckboxes = () => {
        if (userType === UserTypes.GEMEENTEMEDEWERKER && showLinkChecks) {
            return <div>
                {checkboxStatussen.showLidVanSportraad ?
                    lidVanSportraadCheckbox
                    : null}
                {checkboxStatussen.showErkendDoor ?
                    erkendDoorCheckbox
                    : null}
                {checkboxStatussen.showGesubsidieerdDoor ?
                    gesubsidieerdDoorCheckbox
                    : null}
            </div>;
        }

        return null;
    };

    const formContent = () => {
        if (models && models.length) {
            return <Section>
                <Table
                    headers={tableHeaders}
                    headerSizes={tableHeaderSizes}
                >
                    {linkRows}
                </Table>
                {showCheckboxes()}
            </Section>;
        }

        if (isNew && userType === UserTypes.FEDERATIEMEDEWERKER)
            return <Section><p style={{ 'color': '#595959' }}>Lidmaatschap aangevraagd voor {federatieNaam}</p></Section>;

        if (userType === UserTypes.GEMEENTEMEDEWERKER)
            return <div>
                {lidVanSportraadCheckbox}
                {erkendDoorCheckbox}
                {gesubsidieerdDoorCheckbox}
            </div>;

        return null;
    };

    return (
        <Form name="links"
            headerVisible={false}
            isNotRequired
            onUndoButtonClick={onUndo}
            undoButtonVisible={!undoButtonDisabled && userType === UserTypes.WEBSITEBEZOEKER}
            rightButtonLabel={userType === UserTypes.WEBSITEBEZOEKER || showLinkChecks || identificatieCodeChanged ? "Bewaar" : null}
            onRightButtonClick={onSave}
            leftButtonLabel={userType === UserTypes.WEBSITEBEZOEKER ? "Voeg toe" : null}
            onLeftButtonClick={onAdd}>
            <Section>
                <p style={{ 'fontSize': '18px', 'color': '#595959' }}>Organisaties die deze organisatie overkoepelen:</p>
            </Section>
            {formContent()}
        </Form>
    );
};

LinkOverzichtForm.propTypes = {
    models: PropTypes.array,
    disabled: PropTypes.bool,
    isNew: PropTypes.bool,
    federatieNaam: PropTypes.string,
    federatieId: PropTypes.string,
    sportVlaanderenRoot: PropTypes.string,
    onChange: PropTypes.func,
    onChangeLinksCheck: PropTypes.func,
    onEditIdentificatieCode: PropTypes.func,
    onUndo: PropTypes.func,
    onAdd: PropTypes.func,
    onSave: PropTypes.func,
    undoButtonDisabled: PropTypes.bool,
    userType: PropTypes.string,
    checkboxStatussen: PropTypes.object,
    showLinkChecks: PropTypes.bool,
    identificatieCodeChanged: PropTypes.bool
};

export default LinkOverzichtForm;
